// src/utils/debounce.js
var debounce = (func, timeout = 300) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(func, args);
    }, timeout);
  };
};
var debounce_default = debounce;

// src/extenders/predictive-search.js
var PredictiveSearch = class extends HTMLElement {
  constructor() {
    super();
    const predictiveSearchElement = this;
    const searchModalElement = document.querySelector("#search-modal");
    const searchModalFormElement = predictiveSearchElement.querySelector("form");
    const searchInput = this.querySelector('input[type="search"]');
    const predictiveSearchResultsElement = document.querySelector(".predictive-search-results");
    const predictiveSearchResultsSectionId = predictiveSearchResultsElement.getAttribute("data-section-id");
    const searchSuggestionsElements = document.querySelectorAll("#search-suggestion");
    const mobileNavigationToggle = document.querySelector(".mobile-navigation-toggle");
    const closeButton = this.querySelector("#search-modal-handler");
    const searchCloseButtonsDesktop = this.querySelectorAll(".js-search-close");
    const openSearchModalButtons = document.querySelectorAll(".js-open-search-modal");
    const searchCloseButtonDesktop = document.querySelector("#js-search-close-desktop");
    const searchCloseButtonMobile = document.querySelector("#js-search-close-mobile");
    const openSearchModalButtonMobile = document.querySelector("#js-open-search-modal-mobile");
    const megaMenuCurtain = document.querySelector("#js-menu-curtain");
    const showSearchModal = () => {
      searchModalElement.ariaHidden = false;
      openSearchModalButtonMobile.classList.remove("opacity-100");
      openSearchModalButtonMobile.classList.add("opacity-0");
      searchCloseButtonDesktop.classList.remove("opacity-0");
      searchCloseButtonDesktop.classList.add("opacity-100");
      searchCloseButtonDesktop.classList.add("cursor-pointer");
      searchCloseButtonMobile.classList.remove("opacity-0");
      searchCloseButtonMobile.classList.add("opacity-100");
      megaMenuCurtain.classList.add("opacity-0");
      megaMenuCurtain.classList.remove("opacity-100");
    };
    const hideSearchModal = () => {
      searchModalElement.ariaHidden = true;
      openSearchModalButtonMobile.classList.remove("opacity-0");
      openSearchModalButtonMobile.classList.add("opacity-100");
      searchCloseButtonDesktop.classList.remove("opacity-100");
      searchCloseButtonDesktop.classList.add("opacity-0");
      searchCloseButtonDesktop.classList.remove("cursor-pointer");
      searchCloseButtonMobile.classList.remove("opacity-100");
      searchCloseButtonMobile.classList.add("opacity-0");
      megaMenuCurtain.classList.remove("opacity-0");
      megaMenuCurtain.classList.add("opacity-100");
    };
    openSearchModalButtons.forEach((openSearchModalButton) => {
      openSearchModalButton.addEventListener("click", () => {
        showSearchModal();
      });
    });
    const searchCurtain = document.querySelector("#js-search-curtain");
    searchCurtain.addEventListener("click", debounce_default(() => {
      hideSearchModal();
    }), 1);
    searchCloseButtonsDesktop.forEach((searchCloseButtonDesktop2) => {
      searchCloseButtonDesktop2.addEventListener("click", () => {
        hideSearchModal();
      });
    });
    const setLoadingState = () => {
      predictiveSearchResultsElement.style.opacity = "0.5";
      const elementsToAddLoadingState = [
        ".product-button"
      ];
      elementsToAddLoadingState.forEach((loadingQuerySelector) => {
        const allLoadingElements = searchModalElement.querySelectorAll(loadingQuerySelector);
        allLoadingElements.forEach((loadingElement) => {
          loadingElement.classList.add("js-loading");
        });
      });
    };
    const removeLoadingState = () => {
      predictiveSearchResultsElement.style.opacity = "1.0";
      const elementsToAddLoadingState = [
        ".product-button"
      ];
      elementsToAddLoadingState.forEach((loadingQuerySelector) => {
        const allLoadingElements = searchModalElement.querySelectorAll(loadingQuerySelector);
        allLoadingElements.forEach((loadingElement) => {
          loadingElement.classList.remove("js-loading");
        });
      });
    };
    const renderSections = (dom, sectionsArray) => {
      predictiveSearchResultsElement.style.opacity = "1.0";
      sectionsArray.forEach((section) => {
        const source = dom.querySelector(section);
        const destination = document.querySelector(section);
        if (destination) {
          destination.innerHTML = source.innerHTML;
        }
      });
    };
    const handleSearchInput = (searchTerm) => {
      const sectionsArray = [
        ".predictive-search-results"
      ];
      const url = `/search/suggest?q=${searchTerm}&resources[type]=product,collection,article,page&section_id=${predictiveSearchResultsSectionId}`;
      if (closeButton && closeButton.ariaExpanded == "false") {
        closeButton.ariaExpanded = true;
      }
      setLoadingState();
      fetch(url).then((r) => r.text()).then((html) => {
        const parser = new DOMParser();
        const dom = parser.parseFromString(html, "text/html");
        renderSections(dom, sectionsArray);
      }).catch((error) => {
        removeLoadingState();
        throw error;
      });
    };
    const resetSearchResults = () => {
      if (window.innerWidth < 768) {
        searchModalElement.ariaHidden = true;
      }
      searchInput.value = "";
      const sectionsArray = [
        ".predictive-search-results"
      ];
      const url = `${window.location.pathname}?section_id=${predictiveSearchResultsSectionId}`;
      if (closeButton && closeButton.ariaExpanded == "true") {
        closeButton.ariaExpanded = false;
      }
      setLoadingState();
      fetch(url).then((r) => r.text()).then((html) => {
        const parser = new DOMParser();
        const dom = parser.parseFromString(html, "text/html");
        removeLoadingState();
        renderSections(dom, sectionsArray);
      }).catch((error) => {
        removeLoadingState();
        throw error;
      });
    };
    document.addEventListener("click", function(e) {
      let clicks = 0;
      const searchClickElements = document.querySelectorAll(".search-click-block");
      const allCloseSearchModalEleemnts = document.querySelectorAll("#search-modal-handler");
      allCloseSearchModalEleemnts.forEach((element) => {
        if (element.contains(e.target)) {
          document.querySelectorAll("predictive-search").forEach((searchElement) => {
            searchElement.querySelector('input[type="search"]').value = "";
          });
          if (element.ariaExpanded == "false") {
            resetSearchResults();
          }
        }
      });
      if (e.target === searchInput) {
        if (closeButton && closeButton.ariaExpanded == "false") {
          closeButton.ariaExpanded = true;
        }
      }
      searchClickElements.forEach((element) => {
        if (e.target !== element && !element.contains(e.target)) {
          clicks++;
        }
      });
      if (clicks === searchClickElements.length) {
        const searchModalHandlerButton = document.getElementById("search-modal-handler");
        if ((searchModalHandlerButton == null ? void 0 : searchModalHandlerButton.ariaExpanded) == "true") {
          searchModalHandlerButton.click();
        }
      }
    });
    if (searchInput) {
      searchInput.addEventListener("input", debounce_default((event) => {
        if (event.target.value !== "") {
          handleSearchInput(event.target.value);
        } else {
          if (window.innerWidth > 768) {
            resetSearchResults();
          }
        }
      }));
      if (searchInput.value !== "") {
        handleSearchInput(searchInput.value);
      }
    }
    if (searchSuggestionsElements) {
      searchSuggestionsElements.forEach((searchSuggestionElement) => {
        searchSuggestionElement.addEventListener("click", () => {
          resetSearchResults();
        });
      });
    }
    if (mobileNavigationToggle) {
      mobileNavigationToggle.addEventListener("click", () => {
        resetSearchResults();
      });
    }
    searchModalFormElement.addEventListener("reset", () => {
      resetSearchResults();
    });
    document.addEventListener("modal:state", (event) => {
      if (event.detail.ariaControls == "search-modal" && event.detail.state === "open") {
        const inputElement = predictiveSearchElement.querySelector('input[type="search"]');
        inputElement.focus();
      }
    });
  }
};
if (customElements.get("predictive-search") === void 0) {
  customElements.define("predictive-search", PredictiveSearch);
}
